<dv_navbar></dv_navbar>
<div class="container-fluid">
  <div class="content">
      <router-outlet *ngIf="!isIframe"></router-outlet>
  </div>
</div>
<toaster-container [toasterconfig]="toasterconfig" class="hidden-print"></toaster-container>
<div kendoDialogContainer></div>